import { render } from "./bannerAdd.vue?vue&type=template&id=3aa92856&scoped=true"
import script from "./bannerAdd.vue?vue&type=script&lang=js"
export * from "./bannerAdd.vue?vue&type=script&lang=js"

import "./bannerAdd.vue?vue&type=style&index=0&id=3aa92856&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa92856"]])

export default __exports__